import React, { useContext } from 'react'
import UserContext from '@context/UserContext'
import DashboardCard from '../dashboard/DashboardCard'
import { ArrowSquareOut } from '@phosphor-icons/react'
import { navigate } from 'gatsby'

// assets
import thumbBikiniSets from '@images/BeachClub/dashboard-thumb-1.webp'
import thumb20Off from '@images/BeachClub/dashboard-thumb-2.webp'
import thumb20OffPH from '@images/BeachClub/dashboard-thumb-2-ph.webp'
import thumbStickerPack from '@images/BeachClub/dashboard-thumb-3.webp'
import thumbFreeShipping from '@images/BeachClub/dashboard-thumb-4.webp'
import thumbToteBag from '@images/BeachClub/dashboard-thumb-5.webp'
import thumbRedeem from '@images/BeachClub/dashboard-thumb-6.svg'

const RedeemExcitingRewards = () => {
	const { isLoggedIn, showRegisterFormModal } = useContext(UserContext)

	const handleViewAllRewards = (e) => {
		e.preventDefault()
		if(isLoggedIn)
			navigate('/user-account/blackbough-beach-club/my-rewards')
		else
			showRegisterFormModal()
	}
	
	return (
		<React.Fragment>
			<div className='p-4 bg-white md:justify-self-center'>
				<div className='space-y-2 md:text-center'>
					<p className='text-lg md:text-3xl font-medium text-[#3D3D3D]'>Redeem Exciting Rewards</p>
					<span className='text-[#4F4F4F] text-sm md:text-md'>Browse exclusive rewards and redeem your favorites with your points.</span>
				</div>

				<div className='mt-6 grid grid-cols-6 gap-2 lg:gap-4 items-start'>
					<DashboardCard 
						className='block landing-page-redeem-card'
						image={thumbBikiniSets}
						title='Bikini Sets'
						titleIcon={<ArrowSquareOut className='text-black' size={16} />}
						text='Redeem bikini sets starting at 2,500 BB Bucks!'
						link='/collections/blackbough-beach-club-rewards-bikinis'
						underlineTitle
					/>
                    <DashboardCard
                        className='landing-page-redeem-card' 
                        image={process.env.GATSBY_STORE !== "PH" ? thumb20Off : thumb20OffPH}
                        title={process.env.GATSBY_STORE !== "PH" ? `Up to $20 Off` : `Up to P1200 Off`}
                        text='Unlock Discounts with Your BB Bucks'
                    />
					<DashboardCard
						className='landing-page-redeem-card' 
						image={thumbFreeShipping}
						title='Free Shipping'
						text='Unlock free shipping with just 2,000 BB Bucks!'
					/>
					<DashboardCard
						className='landing-page-redeem-card' 
						image={thumbStickerPack}
						title='Sticker Pack'
						text='Sticker Packs for Just 500 BB Bucks!'
					/>
					<DashboardCard
						className='landing-page-redeem-card' 
						image={thumbToteBag}
						title='Limited Edition Tote Bag'
						text='Grab exclusive tote bags starting at 3,000 BB Bucks!'
					/>
					<DashboardCard
						className='landing-page-redeem-card !cursor-pointer !pointer-events-auto' 
						image={thumbRedeem}
						title='View All Rewards'
						titleIcon={<ArrowSquareOut className='text-black' size={16} />}
						text='Explore all available rewards and start redeeming today!'
						onClick={(e) => handleViewAllRewards(e)}
						underlineTitle
					/>
				</div>
			</div>
		</React.Fragment>
	)
}

export default RedeemExcitingRewards